import { useEffect, useState } from "react";

/**
 * Drop-in replacement for the `react-ip-details` package.
 * That package called geolocation-db.com which is blocked / dead and flooded
 * the console with ERR_CONNECTION_REFUSED. We only need a public IPv4 for
 * clock-in logs — fetch it from ipify (already used elsewhere in the app).
 */
export default function useReactIpLocation(_options = {}) {
  const [ipResponse, setIpResponse] = useState(null);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const res = await fetch("https://api.ipify.org?format=json");
        if (!res.ok) throw new Error(`ipify ${res.status}`);
        const data = await res.json();
        if (cancelled) return;
        const ip = data?.ip || null;
        setIpResponse(
          ip
            ? {
                IPv4: ip,
                ip,
                city: null,
                country_name: null,
                latitude: null,
                longitude: null,
                state: null,
              }
            : {}
        );
      } catch (_err) {
        if (!cancelled) setIpResponse({});
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return { ipResponse };
}
